import { AnalyticsEvent } from "Shared/services/analytics/config";
import {
  ANALYTICS_EVENT_ATTRIBUTES,
  ANALYTICS_EVENT_NAMES,
} from "Shared/services/analytics/constants";
import { GA4_EVENT_CATEGORY, trackEventConditionally } from "Shared/services/analytics/services/thresholdManager";

export enum DYNAMIC_SCREENER_QUESTION_TYPES {
  SINGLE_CHOICE = 'single_choice',
  MULTI_CHOICE  = 'multi_choice',
  OPEN_ENDED    = 'open_ended'
}

/**
 * Sends analytic event for viewing a dynamic screener question
 * @param currentStep Current step number (1-based)
 * @param surveyId The survey ID
 * @param providerId The provider ID
 * @param questionId The question ID
 * @param questionType The type of question (single_choice, multi_choice, open_ended)
 * @param totalSteps Total number of screening questions
 * @returns void
 */
export const analyticsTrackDynamicScreenerStep = (
  currentStep : number,
  surveyId    : string,
  providerId  : string,
  questionId  : string,
  questionType: DYNAMIC_SCREENER_QUESTION_TYPES,
  totalSteps  : number
): void => {
  const event: AnalyticsEvent = {
    event: ANALYTICS_EVENT_NAMES.view_item_list,
    attributes: {
      [ANALYTICS_EVENT_ATTRIBUTES.item_id]       : currentStep,
      [ANALYTICS_EVENT_ATTRIBUTES.item_name]     : surveyId,
      [ANALYTICS_EVENT_ATTRIBUTES.item_brand]    : providerId,
      [ANALYTICS_EVENT_ATTRIBUTES.item_category] : 'survey_dynamic_screener_steps',
      [ANALYTICS_EVENT_ATTRIBUTES.item_category2]: questionId,
      [ANALYTICS_EVENT_ATTRIBUTES.item_category3]: questionType,
      [ANALYTICS_EVENT_ATTRIBUTES.item_category4]: totalSteps,
      [ANALYTICS_EVENT_ATTRIBUTES.item_list_name]: `userid-${Date.now()}`,
      [ANALYTICS_EVENT_ATTRIBUTES.index]         : currentStep,
      [ANALYTICS_EVENT_ATTRIBUTES.quantity]      : 1
    }
  };

  trackEventConditionally(GA4_EVENT_CATEGORY.dynamic_screener, [event]);
};
